import { ContentLibraryFolderApi } from '../../../api/contentLibrary/models/content-library-folder.api.model';
import { BaseModel } from '../../../Common/Basic/models/base.model';
import { clone } from 'underscore';


export class ContentLibraryFolderModel extends BaseModel<ContentLibraryFolderModel, ContentLibraryFolderApi> {

    id?: number;
    name?: string;
    // fe only
    count?: number;

    constructor(apiModel?: ContentLibraryFolderApi) {
        super();
        if (apiModel) {
            this.id = apiModel?.id;
            this.name = apiModel.name;
            this.count = 0;
        }
    }

    toApiModel(): ContentLibraryFolderApi {
        return {
            id: this.id,
            name: this.name
        };
    }

    constructFromApiModel(apiModel: ContentLibraryFolderApi): ContentLibraryFolderModel {
        return new ContentLibraryFolderModel(apiModel);
    }

    clone(): ContentLibraryFolderModel {
        return new ContentLibraryFolderModel(clone(this.toApiModel()));
    }

    equals(): boolean {
        return JSON.stringify(this.toApiModel()) === JSON.stringify(this.toApiModel());
    }

    constructfromApiModel(apiModel: ContentLibraryFolderApi): void {
        this.id = apiModel.id;
        this.name = apiModel.name;
    }

    constructDefault(): void {
        this.id = null;
        this.name = null;
    }
}
